<script>
  import { onMount } from "svelte";
  import { fade } from 'svelte/transition';

  // Service
  import { OperationCommonInfoService } from "../../Core/Service/OperationCommonInfoService";
  import { SheetHotelProductService } from "../Service/SheetHotelProductService";

  // Support
  import { modifyProductViewHeightSupport } from "../../Core/Support/ModifyProductViewHeightSupport";
  import { goToTopSupport } from "../../Core/Support/GoToTopSupport";
  import {setProductHeightSupport} from "../../Core/Support/SetProductHeightSupport";

  // Component
  import FlagshipProductComponent from "../Component/FlagshipProduct/FlagshipProductComponent.svelte";
  import NavBarComponent from "../Component/NavBar/NavBarComponent.svelte";
  import ProductListComponent from "../Component/Product/ProductListComponent.svelte";
  import ActiveRuleComponent from "../Component/ActiveRule/ActiveRuleComponent.svelte";

  export let google_spread_id = "";
  export let common_config_sheet_id = "";

  let is_loader_visible = true;
  let flagship_sheets_list = []; // 主打商品
  let active_rule_sheets_list = []; // 活動辦法
  let HotelSegment = {}; // 各主題商品 (已分類)
  let hotel_product_list = [];
  let hotel_segment_name_list = [];

  onMount(async () => {
    await getOperationCommonConfigInfoController();
    await getThemeProductController();
    await modifyProductViewHeight(0);
  });


  /***
   * 取得 “公用區塊” 資訊
   */
  async function getOperationCommonConfigInfoController() {
    let operationCommonInfoService = OperationCommonInfoService();

    //  取得主打產品及注意事項設定檔
    let OperationCommonConfig = await operationCommonInfoService.getOperationCommonConfig(google_spread_id, common_config_sheet_id);

    // 取得各主題主打商品及注意事項內容
    flagship_sheets_list = await operationCommonInfoService.getFlagShipInfo(google_spread_id, OperationCommonConfig.flagship_product.sheet_id);
    active_rule_sheets_list = await operationCommonInfoService.getActiveRules(google_spread_id, OperationCommonConfig.active_rule.sheet_id);
  }


  /***
   * 取得 “主題產品” 資訊
   */
  async function getThemeProductController() {

    // 取得 google sheet 產品資訊服務
    let sheetHotelProductService = SheetHotelProductService();

    // 取得各主題旅館資訊 (未分類)
    HotelSegment = await sheetHotelProductService.getHotelSegmentDetail(google_spread_id, flagship_sheets_list);
    hotel_product_list = HotelSegment.hotel_product_list;
    hotel_segment_name_list = HotelSegment.hotel_segment_name_list

    is_loader_visible = false
  }

  /***
   * 產品視窗高度依各主題產品高度訂定
   */
  async function modifyProductViewHeight(num) {
    await setProductHeightSupport().setProductNameHeight(".product_name_height");
    await setProductHeightSupport().setFeatureNameHeight(".feature_name_height");
    await modifyProductViewHeightSupport(num);
  }


  /***
   * 點選頁籤時跳至產品最高點
   */
  function setAnchor() {
    goToTopSupport();
  }
</script>

{#if is_loader_visible}
  <div id="loader" transition:fade>
    <div class="loader_earth"></div>
  </div>
{/if}

<div class="tourPage_theme">
  <input type="radio" id="nav1" name="slidenav" checked />
  <input type="radio" id="nav2" name="slidenav" />
  <input type="radio" id="nav3" name="slidenav" />
  <input type="radio" id="nav4" name="slidenav" />
  <input type="radio" id="nav5" name="slidenav" />
  <input type="radio" id="nav6" name="slidenav" />

  <NavBarComponent
    {modifyProductViewHeight}
    {setAnchor}
    nav_item_list={flagship_sheets_list} />

  <FlagshipProductComponent let:product_index={index} {flagship_sheets_list}>
    <ProductListComponent {index} {hotel_product_list} {hotel_segment_name_list} />
  </FlagshipProductComponent>

  <!-- 注意事項 START -->
  <ActiveRuleComponent {active_rule_sheets_list} />
  <!-- 注意事項 END -->
</div>
